module.exports = __webpack_public_path__ + "static/media/lan1.71e11e6b.jpg";